import type en from '../en/devices'
import type { Translation } from '../types'

/** The device brands: registering a device and its page */
const devices: Translation<typeof en> = {
  "devices.registered": "Appareil enregistré",
  "devices.registrationFailed": "Échec de l’enregistrement",
  "devices.siteRegistered": "{name} enregistré",
  "devices.registerAnother": "En enregistrer un autre",
  "devices.openDevice": "Ouvrir l’appareil",
  "devices.viewAllSites": "Afficher tous les sites",
  "devices.deviceAddress": "Adresse de l’appareil *",
  "devices.username": "Nom d’utilisateur *",
  "devices.password": "Mot de passe *",
  "devices.siteName": "Nom du site",
  "devices.connectRegister": "Connecter et enregistrer",
  "devices.directDevice": "Appareil direct",
  "devices.deviceUrl": "URL de l’appareil *",
  "devices.reachableVpn": "Doit être joignable depuis ce serveur — généralement via le tunnel VPN.",
  "devices.storedEncrypted": "Stocké chiffré.",
  "devices.imported": { one: "{count} appareil importé", other: "{count} appareils importés" },
  "devices.mikrotik.transport.rest": "API REST (RouterOS 7)",
  "devices.mikrotik.transport.apiSsl": "Protocole API via TLS",
  "devices.mikrotik.transport.api": "Protocole API (non chiffré)",
  "devices.mikrotik.radios": { one: "{count} radio", other: "{count} radios" },
  "devices.mikrotik.connectedOver": "Connecté via : {transport}",
  "devices.mikrotik.registerTitle": "Enregistrer un MikroTik",
  "devices.mikrotik.registerSubtitle": "Un routeur, un point d’accès ou une radio point à point / point à multipoint",
  "devices.mikrotik.addressHint": "Doit être joignable depuis ce serveur — généralement son adresse VPN. Le type de connexion est détecté : REST sur RouterOS 7, le service API (8729 ou 8728) sur RouterOS 6.43 et plus récent.",
  "devices.mikrotik.forceHint": "Pour en imposer un, écrivez",
  "devices.or": "ou",
  "devices.mikrotik.accountHint": "Utilisez un compte disposant de tous les droits si vous voulez configurer l’appareil d’ici ; un compte en lecture seule suffit pour la surveillance. Stocké chiffré.",
  "devices.mikrotik.siteNameHint": "(facultatif — par défaut l’identité de l’appareil)",
  "devices.mikrotik.siteNamePlaceholder": "p. ex. Secteur nord",
  "devices.mikrotik.radioLinkTitle": "Pour une liaison radio",
  "devices.mikrotik.radioLinkText": ", enregistrez chaque extrémité comme un site distinct. Le point d’accès affiche alors chaque station avec son signal et son débit ; une station également enregistrée ici est reconnue comme liaison, même sur un simple point d’accès Wi-Fi.",
  "devices.peplink.foundOrgs": { one: "{count} organisation trouvée", other: "{count} organisations trouvées" },
  "devices.peplink.discoveryFailed": "Échec de la recherche",
  "devices.peplink.telemetryNote": "La télémétrie SpeedFusion et WAN apparaît après la première synchronisation.",
  "devices.peplink.registerTitle": "Enregistrer un Peplink",
  "devices.peplink.registerSubtitle": "Connexion via InControl2 ou directement à un routeur",
  "devices.peplink.ic2Desc": "Importe tous les appareils d’une organisation ou d’un groupe.",
  "devices.peplink.directDesc": "Interroge localement un routeur Balance/MAX.",
  "devices.peplink.clientId": "ID client *",
  "devices.peplink.clientSecret": "Secret client *",
  "devices.createUnder": "À créer sous",
  "devices.peplink.ic2Url": "URL de l’API IC2",
  "devices.peplink.discoverOrgs": "Rechercher les organisations",
  "devices.peplink.organisation": "Organisation *",
  "devices.peplink.group": "Groupe",
  "devices.peplink.blankAllGroups": "(vide = tous les groupes)",
  "devices.peplink.allGroups": "Tous les groupes",
  "devices.peplink.siteNamePlaceholder": "p. ex. Bateau 1 — MAX Transit",
  "devices.teltonika.importedFromRms": { one: "{count} appareil importé depuis RMS", other: "{count} appareils importés depuis RMS" },
  "devices.teltonika.telemetryNote": "La télémétrie cellulaire apparaîtra après la première synchronisation.",
  "devices.teltonika.registerTitle": "Enregistrer un Teltonika",
  "devices.teltonika.registerSubtitle": "Connexion via le cloud RMS ou directement à un routeur",
  "devices.teltonika.rmsCloud": "Cloud RMS",
  "devices.teltonika.rmsDesc": "Importe tous les appareils de votre entreprise RMS. Idéal pour les flottes.",
  "devices.teltonika.directDesc": "Interroge un routeur RutOS via son API locale.",
  "devices.teltonika.pat": "Jeton d’accès personnel *",
  "devices.teltonika.createInRms": "À créer dans RMS sous",
  "devices.teltonika.rmsUrl": "URL de l’API RMS",
  "devices.teltonika.defaultRms": "Laisser vide pour le RMS public par défaut.",
  "devices.teltonika.siteNamePlaceholder": "p. ex. Fourgon 3 — RUTX11",
  "devices.unifihost.consoles": { one: "{count} console", other: "{count} consoles" },
  "devices.unifihost.found": "{consoles} et {sites} trouvés",
  "devices.unifihost.verificationFailed": "Échec de la vérification",
  "devices.unifihost.importedSites": { one: "{count} site importé", other: "{count} sites importés" },
  "devices.unifihost.importFailed": "Échec de l’importation",
  "devices.unifihost.doneNote": "Site Manager fournit en lecture seule la télémétrie de la flotte et les mesures du FAI. Pour la configuration, ajoutez aussi le contrôleur local comme site UniFi.",
  "devices.unifihost.importMore": "Importer davantage",
  "devices.unifihost.title": "Connecter UniFi Site Manager",
  "devices.unifihost.subtitle": "Surveillance de toute la flotte sur chaque console UniFi de votre compte",
  "devices.unifihost.apiKey": "Clé API *",
  "devices.unifihost.apiKeyPlaceholder": "Clé API UniFi Site Manager",
  "devices.unifihost.createAt": "À créer sur",
  "devices.unifihost.baseUrl": "URL de base de l’API",
  "devices.unifihost.verifyDiscover": "Vérifier et rechercher",
  "devices.unifihost.importAs": "Importer en tant que",
  "devices.unifihost.perSite": "Un site par site UniFi",
  "devices.unifihost.recommended": "{sites} — recommandé",
  "devices.unifihost.perConsole": "Un site par console",
  "devices.unifihost.consolesToImport": "Consoles à importer",
  "devices.unifihost.console": "console",
  "devices.unifihost.importConsoles": { one: "Importer {count} console", other: "Importer {count} consoles" },
  "devices.velanox.registeredFromEndpoint": { one: "{count} boîtier enregistré depuis l’endpoint", other: "{count} boîtiers enregistrés depuis l’endpoint" },
  "devices.velanox.standaloneRegistered": "Boîtier autonome enregistré : {name}",
  "devices.velanox.boxesRegistered": { one: "{count} boîtier enregistré", other: "{count} boîtiers enregistrés" },
  "devices.velanox.boxRegistered": "Boîtier enregistré",
  "devices.velanox.endpointNote": "Un site a été créé pour chaque boîtier de l’endpoint. Ils se synchroniseront automatiquement.",
  "devices.velanox.boxNote": "Le boîtier autonome a été ajouté comme site.",
  "devices.velanox.registerTitle": "Enregistrer un site Velanox",
  "devices.velanox.registerSubtitle": "Connectez un endpoint Velanox One Speed ou un boîtier autonome",
  "devices.velanox.endpoint": "Endpoint",
  "devices.velanox.endpointDesc": "Regroupe plusieurs boîtiers. Crée automatiquement un site par boîtier.",
  "devices.velanox.standalone": "Boîtier autonome",
  "devices.velanox.standaloneDesc": "Un seul boîtier interrogé directement.",
  "devices.velanox.endpointName": "Nom de l’endpoint",
  "devices.velanox.endpointNamePlaceholder": "p. ex. Endpoint Amsterdam",
  "devices.velanox.endpointNameHint": "Sert d’étiquette — les noms des boîtiers proviennent de l’API.",
  "devices.velanox.siteNamePlaceholder": "p. ex. Unité mobile Starlinkhuren",
  "devices.velanox.url": "URL Velanox *",
  "devices.velanox.baseUrlEndpoint": "URL de base du serveur Flask de l’endpoint.",
  "devices.velanox.baseUrlBox": "URL de base du serveur HTTP du boîtier autonome.",
  "devices.velanox.token": "Jeton d’intégration *",
  "devices.velanox.setVia": "Défini via",
  "devices.velanox.onNode": "sur le nœud Velanox.",
  "devices.velanox.descriptionPlaceholder": "Notes facultatives sur cette connexion",
  "devices.actionFailed": "Échec de l’action",
  "devices.actionSent": "« {action} » envoyé",
  "devices.action.reboot": "redémarrage",
  "devices.action.firmware_check": "vérification du micrologiciel",
  "devices.action.tunnel_reconnect": "reconnexion du tunnel",
  "devices.action.wan_enable": "activation du WAN",
  "devices.action.wan_disable": "désactivation du WAN",
  "devices.action.send_sms": "envoi de SMS",
  "devices.action.restart_modem": "redémarrage du modem",
  "devices.action.switch_sim": "changement de SIM",
  "devices.action.restart_network": "redémarrage du réseau",
  "devices.action.roll_key": "renouvellement de la clé",
  "devices.action.restart_service": "redémarrage du service",
  "devices.action.get_stats": "récupération des statistiques",
  "devices.action.fetch_logs": "récupération des journaux",
  "devices.action.starlink_stow": "rangement de l’antenne",
  "devices.action.starlink_unstow": "déploiement de l’antenne",
  "devices.action.starlink_reboot": "redémarrage de l’antenne",
  "devices.upFor": "actif depuis {duration}",
  "devices.memory": "Mémoire",
  "devices.temperature": "Température",
  "devices.openMap": "Ouvrir la carte",
  "devices.controls": "Commandes de l’appareil",
  "devices.checkFirmware": "Vérifier le micrologiciel",
  "devices.sendSms": "Envoyer un SMS",
  "devices.reboot": "Redémarrer",
  "devices.sms.recipient": "Numéro du destinataire",
  "devices.sms.message": "Message",
  "devices.sms.charges": "Envoyé depuis la SIM du routeur. Des frais d’opérateur s’appliquent.",
  "devices.signal.0": "Aucun signal",
  "devices.signal.1": "Très faible",
  "devices.signal.2": "Faible",
  "devices.signal.3": "Moyen",
  "devices.signal.4": "Bon",
  "devices.signal.5": "Excellent",
  "devices.unknown": "inconnu",
  "devices.unknownError": "Erreur inconnue",
  "devices.up": "Actif",
  "devices.connected": "Connecté",
  "devices.loss": "{percent} % de perte",
  "devices.interface": "Interface",
  "devices.ipAddress": "Adresse IP",
  "devices.gateway": "Passerelle",
  "devices.enable": "Activer",
  "devices.disable": "Désactiver",
  "devices.device": "Appareil",
  "devices.firmware": "Micrologiciel",
  "devices.mikrotik.updateCheckDone": "Vérification des mises à jour terminée",
  "devices.mikrotik.installedLatest": "Installée {installed}, dernière {latest}",
  "devices.mikrotik.noNewer": "Aucune version plus récente signalée",
  "devices.mikrotik.backupSaved": "Sauvegarde enregistrée",
  "devices.mikrotik.rebootSent": "Redémarrage envoyé",
  "devices.mikrotik.backInMinute": "L’appareil revient d’ici une à deux minutes.",
  "devices.mikrotik.renamePrompt": "Nom de cette liaison",
  "devices.mikrotik.renameFailed": "Échec du renommage",
  "devices.mikrotik.forgetConfirm": "Oublier {name} ? À utiliser pour une station retirée volontairement — elle réapparaît d’elle-même si elle se reconnecte.",
  "devices.mikrotik.forgetFailed": "Impossible de supprimer la liaison",
  "devices.mikrotik.device": "Appareil MikroTik",
  "devices.mikrotik.updateBadge": "mise à jour {version}",
  "devices.mikrotik.via": "via {transport}",
  "devices.mikrotik.configure": "Configurer",
  "devices.mikrotik.checkUpdates": "Vérifier les mises à jour",
  "devices.mikrotik.backup": "Sauvegarde",
  "devices.mikrotik.rebootConfirm": "Redémarrer cet appareil ? Les liaisons qui passent par lui tombent pendant une à deux minutes.",
  "devices.mikrotik.cannotReach": "Impossible de joindre l’appareil{reason}. Les liaisons ci-dessous sont celles vues en dernier.",
  "devices.mikrotik.links": "Liaisons",
  "devices.mikrotik.wifiClients": { one: "{count} client Wi-Fi", other: "{count} clients Wi-Fi" },
  "devices.mikrotik.radioLinks": "Liaisons radio",
  "devices.mikrotik.noLinks": "Aucune liaison vue pour l’instant. Elles apparaissent après la première synchronisation, dès qu’une station est connectée.",
  "devices.mikrotik.farEnd": "Extrémité distante",
  "devices.mikrotik.signal": "Signal",
  "devices.mikrotik.rate": "Débit ↑ / ↓",
  "devices.mikrotik.quality": "Qualité",
  "devices.mikrotik.distance": "Distance",
  "devices.mikrotik.roleAp": "point d’accès",
  "devices.mikrotik.roleStation": "station",
  "devices.mikrotik.onInterface": "sur {interface}",
  "devices.mikrotik.linkDown": "liaison coupée",
  "devices.mikrotik.seen": "vu {when}",
  "devices.mikrotik.rename": "Renommer",
  "devices.mikrotik.forget": "Oublier cette liaison",
  "devices.mikrotik.noWireless": "Aucune interface sans fil",
  "devices.mikrotik.mode": "Mode",
  "devices.mikrotik.channel": "Canal",
  "devices.mikrotik.state": "État",
  "devices.mikrotik.disabled": "désactivé",
  "devices.mikrotik.running": "actif",
  "devices.mikrotik.notConnected": "non connecté",
  "devices.mikrotik.uplinks": "Liaisons montantes",
  "devices.mikrotik.noUplink": "Aucune liaison montante trouvée. Une interface compte comme telle lorsqu’elle figure dans la liste d’interfaces « WAN » ou porte la route par défaut.",
  "devices.mikrotik.address": "Adresse",
  "devices.mikrotik.order": "Ordre",
  "devices.mikrotik.signalAria": "signal {percent} pour cent",
  "devices.peplink.cannotReach": "Impossible de joindre l’appareil Peplink — vérifiez les identifiants",
  "devices.peplink.wansUp": "WAN actifs",
  "devices.peplink.tunnels": "Tunnels SpeedFusion",
  "devices.storedLine": "Dernière lecture {when} — lecture du routeur en cours…",
  "devices.storedLineNever": "Pas encore lu — lecture du routeur en cours…",
  "devices.peplink.wanLinks": "Liaisons WAN",
  "devices.peplink.unknownCarrier": "Opérateur inconnu",
  "devices.peplink.rebootConfirm": "Redémarrer cet appareil Peplink ? Toutes les liaisons tombent pendant 1 à 2 minutes.",
  "devices.teltonika.cannotReach": "Impossible de joindre l’appareil Teltonika — vérifiez les identifiants et la connectivité",
  "devices.teltonika.modems": "Modems",
  "devices.teltonika.power.title": "Alimentation",
  "devices.teltonika.power.noBattery": "Pas de batterie",
  "devices.teltonika.power.onMains": "Sur secteur",
  "devices.teltonika.power.onBattery": "Sur alimentation de secours depuis {time} ({duration})",
  "devices.teltonika.power.notKnown": "Inconnue",
  "devices.teltonika.power.has": "A une alimentation de secours (UPS)",
  "devices.teltonika.power.notChanged": "Le réglage de l'alimentation de secours n'a pas été modifié",
  "devices.teltonika.noModems": "Aucun modem cellulaire signalé",
  "devices.teltonika.noOperator": "Aucun opérateur",
  "devices.teltonika.band": "Bande {band}",
  "devices.teltonika.dataUsage": "Consommation de données",
  "devices.teltonika.restartModem": "Redémarrer le modem",
  "devices.teltonika.switchSimConfirm": "Basculer {modem} sur l’autre emplacement SIM ?",
  "devices.teltonika.switchSim": "Changer de SIM",
  "devices.teltonika.wanInterfaces": "Interfaces WAN",
  "devices.teltonika.noWans": "Aucune interface WAN signalée",
  "devices.teltonika.rebootConfirm": "Redémarrer cet appareil ? Il sera hors ligne pendant 1 à 2 minutes.",
  "devices.teltonika.vpnMode": "Programmé sur le banc",
  "devices.teltonika.vpnModeDesc": "Par son numéro de série, avec son propre certificat VPN",
  "devices.teltonika.serial": "Numéro de série",
  "devices.teltonika.serialHint": "Comme sur son étiquette ; les espaces ne comptent pas. Le même numéro de série à nouveau met à jour ce routeur et lui donne un nouveau certificat.",
  "devices.teltonika.model": "Modèle",
  "devices.teltonika.modelHint": "Le modèle peut rester vide : le routeur indique le sien à sa première connexion.",
  "devices.teltonika.vpnLogin": "Identifiant Velanox sur le routeur",
  "devices.teltonika.vpnLoginHint": "L’utilisateur avec lequel Velanox se connecte par le tunnel. Le mot de passe est stocké chiffré et n’est plus jamais affiché.",
  "devices.teltonika.addRouter": "Ajouter le routeur",
  "devices.teltonika.routerAdded": "Routeur ajouté",
  "devices.teltonika.routerAddedText": "Son certificat VPN est délivré : chargez son .ovpn sur le routeur depuis cette page.",
  "devices.teltonika.addFailed": "Le routeur n’a pas été ajouté",
  "devices.teltonika.vpn.waiting": "En attente du routeur",
  "devices.teltonika.vpn.noAccount": "Ce routeur n’a pas encore de certificat VPN : ajoutez-le à nouveau avec le même numéro de série pour en délivrer un.",
  "devices.teltonika.vpn.newCertConfirm": "Délivrer un nouveau certificat VPN pour {name} ? L’actuel cesse aussitôt de fonctionner ; le routeur reste hors du VPN jusqu’à ce qu’il ait le nouveau fichier.",
  "devices.teltonika.vpn.newCertDoneText": "Téléchargez le nouveau .ovpn et chargez-le sur le routeur.",
  "devices.teltonika.vpn.stepsTitle": "Le charger sur le routeur (WebUI RutOS)",
  "devices.teltonika.vpn.step1": "Services → VPN → OpenVPN : ajoutez une instance client nommée velanox.",
  "devices.teltonika.vpn.step2": "Activez-la, activez « {option} » et choisissez {file}. Enregistrez.",
  "devices.teltonika.vpn.step3": "Le routeur se connecte et cette carte affiche Connecté en quelques minutes.",
  "devices.unifihost.consoleName": "Console UniFi",
  "devices.unifihost.readOnly": "Vue cloud en lecture seule. Pour modifier les paramètres, enregistrez le contrôleur local comme site UniFi.",
  "devices.unifihost.online": "en ligne",
  "devices.unifihost.offline": "hors ligne",
  "devices.unifihost.onConsole": "sur cette console",
  "devices.unifihost.connected": "connectés",
  "devices.unifihost.updates": "Mises à jour",
  "devices.unifihost.firmwareAvailable": "micrologiciel disponible",
  "devices.unifihost.ispPerformance": "Performances du FAI",
  "devices.unifihost.last24h": "Dernières 24 h",
  "devices.unifihost.last30d": "30 derniers jours",
  "devices.unifihost.noIsp": "Aucune mesure FAI signalée pour cette console",
  "devices.unifihost.updateBadge": "⬆ mise à jour",
  "devices.velanox.cannotReach": "Impossible de joindre le boîtier Velanox — vérifiez le jeton d’intégration et l’URL",
  "devices.velanox.keyRollPending": "🔑 Renouvellement de clé en attente",
  "devices.velanox.wans": { one: "{count} WAN", other: "{count} WAN" },
  "devices.velanox.encrypted": "🔒 chiffré",
  "devices.velanox.na": "N/D",
  "devices.velanox.rttBonded": "RTT (agrégé)",
  "devices.velanox.packetLoss": "Perte de paquets",
  "devices.velanox.wanPaths": "Chemins WAN",
  "devices.velanox.noWanPaths": "Aucun chemin WAN",
  "devices.velanox.jitter": "Gigue",
  "devices.velanox.loss": "Perte",
  "devices.velanox.weight": "Poids",
  "devices.velanox.anchor": "Ancre",
  "devices.velanox.alive": "Actif",
  "devices.velanox.roaming": "Itinérance",
  "devices.velanox.boxControls": "Commandes du boîtier",
  "devices.velanox.controlsNote": "Les actions sont relayées au boîtier via le canal de gestion. Un redémarrage provoque une brève panne.",
  "devices.velanox.rollKey": "Renouveler la clé",
  "devices.velanox.restartService": "Redémarrer le service",
  "devices.velanox.getStats": "Récupérer les statistiques",
  "devices.velanox.fetchLogs": "Récupérer les journaux",
  "devices.velanox.rebootBox": "Redémarrer le boîtier",
  "devices.velanox.rebootConfirm": "Redémarrer ce boîtier Velanox ? Cela provoque une brève panne.",
  "devices.velanox.starlinkUnavailable": "L’état Starlink n’est pas disponible{reason}.",
  "devices.velanox.loadingStarlink": "Chargement de l’état Starlink…",
  "devices.velanox.noDriver": "Aucun pilote Starlink n’est connecté à ce boîtier. Le boîtier indique driver: null.",
  "devices.velanox.capabilities": "Capacités Starlink",
  "devices.velanox.driver": "Pilote : {driver}",
  "devices.velanox.reposition": "Le repositionnement n’est jamais disponible sur du vrai matériel Starlink — les antennes s’orientent seules.",
  "devices.velanox.dishControls": "Commandes de l’antenne",
  "devices.velanox.greyedNote": "Les boutons sont grisés lorsque l’antenne ne prend pas en charge cette capacité.",
  "devices.velanox.grpcNote": "Remarque : la commande de l’antenne via l’endpoint renvoie 501 (intégration à venir). Utilisez le mode boîtier autonome pour commander l’antenne.",
  "devices.velanox.stow": "Ranger l’antenne",
  "devices.velanox.unstow": "Déployer l’antenne",
  "devices.velanox.rebootDish": "Redémarrer l’antenne",
  "devices.velanox.rebootDishConfirm": "Redémarrer l’antenne Starlink ?",
  "devices.velanox.dishStatus": "État de l’antenne",
  "devices.velanox.notSupported": "{label} non pris en charge par ce boîtier",
  "devices.velanox.preset.firmware": "État du micrologiciel",
  "devices.velanox.preset.gateway": "État des passerelles",
  "devices.velanox.preset.firewall": "Règles du pare-feu",
  "devices.velanox.preset.dhcp": "Baux DHCP",
  "devices.velanox.preset.interfaces": "Interfaces",
  "devices.velanox.preset.arp": "Table ARP",
  "devices.velanox.invalidJson": "Le corps n’est pas un JSON valide",
  "devices.velanox.requestFailed": "Échec de la requête",
  "devices.velanox.passThrough": "Relais OPNsense. Le boîtier applique le niveau d’accès configuré — les appels refusés renvoient 403. Le niveau 3 peut redémarrer ou reconfigurer le pare-feu.",
  "devices.velanox.quickPresets": "Préréglages rapides",
  "devices.velanox.httpMethod": "Méthode HTTP",
  "devices.velanox.apiPath": "Chemin de l’API",
  "devices.velanox.requestBody": "Corps de la requête (JSON, facultatif)",
  "devices.velanox.response": "Réponse",
  "devices.unifihost.connectedSince": "Connecté depuis",
  "devices.unifihost.managedBy": "Géré par",
  "devices.unifihost.mgmt.GATEWAY": "Passerelle",
  "devices.unifihost.mgmt.SWITCH": "Commutateur",
  "devices.unifihost.mgmt.UNMANAGED": "Non géré",
  "devices.unifihost.defaultNetwork": "par défaut",
  "devices.unifihost.security": "Sécurité",
  "devices.unifihost.bands": "Bandes",
  "devices.unifihost.network": "Réseau",
  "devices.unifihost.nativeNetwork": "Réseau natif",
  "devices.unifihost.sec.OPEN": "Ouvert",
  "devices.unifihost.sec.WPA2_PERSONAL": "WPA2-Personnel",
  "devices.unifihost.sec.WPA3_PERSONAL": "WPA3-Personnel",
  "devices.unifihost.sec.WPA2_WPA3_PERSONAL": "WPA2/WPA3-Personnel",
  "devices.unifihost.sec.WPA2_ENTERPRISE": "WPA2-Entreprise",
  "devices.unifihost.sec.WPA3_ENTERPRISE": "WPA3-Entreprise",
  "devices.unifihost.sec.WPA2_WPA3_ENTERPRISE": "WPA2/WPA3-Entreprise",
  "devices.unifihost.why.rejected": "UniFi a refusé la clé API pour cette console. La clé doit appartenir au propriétaire de la console.",
  "devices.unifihost.why.unsupported": "Cette console ne peut pas fournir cette liste via le cloud. Il faut UniFi OS 5.0.3 ou ultérieur, et UniFi Network 10 ou ultérieur pour les réseaux et le Wi-Fi.",
  "devices.unifihost.why.busy": "UniFi limite les requêtes vers cette console. Réessayez dans une minute.",
  "devices.unifihost.why.unreachable": "La console n’a pas répondu via le cloud. Vérifiez qu’elle est en ligne.",
  "devices.unifihost.why.no_match": "Ce site UniFi ne se trouve plus sur sa console.",
  "devices.unifihost.why.failed": "UniFi n’a pas fourni cette liste.",
  "devices.unifilocal.open": "Comment basculer →",
  "devices.unifilocal.title": "Basculer vers le contrôleur local",
  "devices.unifilocal.intro": "La console se connecte au tableau de bord par son propre tunnel VPN ; le tableau de bord la lit et la modifie ensuite via son propre contrôleur. Le site conserve son nom, ses alertes et ses abonnements.",
  "devices.unifilocal.noPermission": "Le basculement nécessite les droits de modifier les sites et de gérer le VPN.",
  "devices.unifilocal.step.account": "Créez le compte VPN de ce site",
  "devices.unifilocal.step.accountText": "Le compte donne à la console son propre certificat et une adresse fixe dans le réseau VPN de l’entreprise.",
  "devices.unifilocal.createAccount": "Créer le compte VPN",
  "devices.unifilocal.creating": "Création du compte…",
  "devices.unifilocal.accountReady": "Prêt : adresse du tunnel {ip}",
  "devices.unifilocal.accountFailed": "Le compte VPN n’a pas pu être créé",
  "devices.unifilocal.step.download": "Téléchargez le fichier VPN",
  "devices.unifilocal.step.downloadText": "Le fichier .ovpn contient le certificat propre à ce site. Gardez-le privé et utilisez-le uniquement sur cette console.",
  "devices.unifilocal.download": "Télécharger le .ovpn",
  "devices.unifilocal.downloadFailed": "Échec du téléchargement",
  "devices.unifilocal.step.client": "Ajoutez-le dans UniFi comme client VPN",
  "devices.unifilocal.client.1": "Dans UniFi Network, ouvrez Settings → VPN → VPN Client et choisissez Create New.",
  "devices.unifilocal.client.2": "Type de VPN : OpenVPN. Donnez-lui un nom, par exemple Velanox.",
  "devices.unifilocal.client.3": "Chargez le fichier .ovpn comme fichier de configuration.",
  "devices.unifilocal.client.4": "Laissez le nom d’utilisateur et le mot de passe vides : le fichier contient le certificat.",
  "devices.unifilocal.client.5": "N’y faites passer aucun trafic : laissez les assistants de routage désactivés et n’ajoutez aucune route de trafic. Seul le tableau de bord utilise ce tunnel.",
  "devices.unifilocal.client.6": "Choisissez Create. La connexion s’établit en moins d’une minute.",
  "devices.unifilocal.waiting": "En attente de la connexion du tunnel…",
  "devices.unifilocal.connected": "Tunnel connecté",
  "devices.unifilocal.step.firewall": "Laissez le tableau de bord atteindre la console",
  "devices.unifilocal.firewall.why": "UniFi place une connexion client VPN dans sa zone External, qui n’atteint pas la console elle-même. Ajoutez une règle de pare-feu qui laisse entrer le tableau de bord :",
  "devices.unifilocal.firewall.1": "UniFi Network 10 : Settings → Policy Engine → Policy Table → Create New Policy. Versions antérieures : Settings → Security → Firewall.",
  "devices.unifilocal.firewall.2": "Source : zone External, adresse IP {ip}.",
  "devices.unifilocal.firewall.3": "Destination : zone Gateway, port 443 (TCP).",
  "devices.unifilocal.firewall.4": "Action : Allow.",
  "devices.unifilocal.serverIpFallback": "l’adresse de tunnel du tableau de bord (la première adresse du réseau des sites)",
  "devices.unifilocal.step.key": "Créez une clé API locale",
  "devices.unifilocal.key.1": "Dans UniFi Network : Settings → Control Plane → Integrations → Create API Key.",
  "devices.unifilocal.key.2": "Copiez la clé : UniFi ne l’affiche qu’une seule fois.",
  "devices.unifilocal.step.switch": "Basculez le site vers son contrôleur local",
  "devices.unifilocal.apiKey": "Clé API locale",
  "devices.unifilocal.controllerUrl": "Adresse du contrôleur",
  "devices.unifilocal.controllerHint": "Renseignée à partir de l’adresse du tunnel. Un UniFi Network Server auto-hébergé : https://<adresse>:8443",
  "devices.unifilocal.testSwitch": "Tester et basculer",
  "devices.unifilocal.testing": "Test en cours…",
  "devices.unifilocal.done": "Le site utilise désormais son contrôleur local",
  "devices.unifilocal.why.rejected": "La console a refusé cette clé API. Créez-en une nouvelle sous Control Plane → Integrations.",
  "devices.unifilocal.why.not_found": "La console a répondu, mais pas à cette adresse. Un UniFi Network Server auto-hébergé utilise https://<adresse>:8443.",
  "devices.unifilocal.why.unreachable": "La console n’a pas répondu par le tunnel. Vérifiez que le client VPN est connecté (étape 3) et que la règle de pare-feu laisse entrer le tableau de bord (étape 4).",
  "devices.unifilocal.why.no_vpn": "Ce site n’a pas encore d’adresse de tunnel (étape 1).",
  "devices.unifilocal.why.failed": "Le test a échoué. Vérifiez l’adresse et la clé API.",
  "devices.unifilocal.manual.intro": "Une console UniFi OS (Dream Machine, Cloud Gateway, Cloud Key) se connecte comme client OpenVPN avec le fichier .ovpn de son site, chargé tel quel.",
  "devices.unifilocal.manual.download": "Téléchargez le fichier .ovpn du site",
  "devices.unifilocal.manual.downloadText": "Dans le tableau des comptes VPN ci-dessus, sur la ligne du site.",
  "devices.unifilocal.manual.add": "Ajoutez le site dans le tableau de bord",
  "devices.unifilocal.manual.addText": "Un site ajouté via Site Manager : ouvrez-le et choisissez la barre bleue ; elle bascule le site avec vous. Un nouveau site : ajoutez un site UniFi avec l’adresse du contrôleur https://<adresse du tunnel>/proxy/network et la clé API locale.",
  "devices.mikrotik.vpnModeHint": "Velanox délivre à l’unité son propre certificat VPN. Chargez-le sur l’unité ; dès qu’elle se connecte, Velanox l’interroge par son tunnel. Rien n’a besoin d’être joignable maintenant.",
  "devices.mikrotik.serial": "Numéro de série",
  "devices.mikrotik.serialHint": "Tel qu’indiqué sur son étiquette ; les espaces et les majuscules ne comptent pas. Le même numéro une nouvelle fois met à jour cette unité et lui donne un nouveau certificat.",
  "devices.mikrotik.unitRoleLabel": "Rôle",
  "devices.mikrotik.unitRoleNone": "Aucun",
  "devices.mikrotik.unitRole.SENDER": "Émetteur",
  "devices.mikrotik.unitRole.RECEIVER": "Récepteur",
  "devices.mikrotik.unitNameHint": "(facultatif — sinon le numéro de série)",
  "devices.mikrotik.vpnAccountHint": "Le compte avec lequel Velanox se connecte par le tunnel. Enregistré chiffré, jamais réaffiché.",
  "devices.mikrotik.addUnit": "Ajouter le MikroTik",
  "devices.mikrotik.unitAdded": "MikroTik ajouté",
  "devices.mikrotik.unitAddedText": "Son certificat VPN est délivré : chargez ses fichiers sur l’unité depuis cette page.",
  "devices.mikrotik.addFailed": "Le MikroTik n’a pas été ajouté",
  "devices.mikrotik.notDeployed.waiting": "En attente du VPN",
  "devices.mikrotik.notDeployed.offline": "Hors ligne · non déployé",
  "devices.mikrotik.waitingText": "L’unité ne s’est pas encore connectée au VPN ; dès qu’elle se connecte, Velanox l’interroge par son tunnel.",
  "devices.mikrotik.vpn.connected": "Connecté",
  "devices.mikrotik.vpn.waiting": "En attente de l’unité",
  "devices.mikrotik.vpn.noAccount": "Cette unité n’a pas encore de certificat VPN : ajoutez-la à nouveau avec le même numéro de série pour en délivrer un.",
  "devices.mikrotik.vpn.tunnelAddress": "Adresse du tunnel",
  "devices.mikrotik.vpn.lastSeen": "Dernière connexion",
  "devices.mikrotik.vpn.never": "Jamais",
  "devices.mikrotik.vpn.downloadOvpn": "Télécharger le .ovpn",
  "devices.mikrotik.vpn.downloadP12": "Télécharger le .p12",
  "devices.mikrotik.vpn.newCert": "Nouveau certificat",
  "devices.mikrotik.vpn.newCertConfirm": "Délivrer un nouveau certificat VPN pour {name} ? L’actuel cesse aussitôt de fonctionner ; l’unité reste hors du VPN jusqu’à ce qu’elle ait les nouveaux fichiers.",
  "devices.mikrotik.vpn.newCertDone": "Nouveau certificat délivré",
  "devices.mikrotik.vpn.newCertDoneText": "Téléchargez les nouveaux fichiers et chargez-les sur l’unité.",
  "devices.mikrotik.vpn.newCertFailed": "Aucun nouveau certificat n’a été délivré",
  "devices.mikrotik.vpn.passphrase": "Phrase secrète de ce .p12 :",
  "devices.mikrotik.vpn.passphraseHint": "Affichée une seule fois, pour ce téléchargement uniquement ; elle n’est pas conservée. Chaque téléchargement en reçoit une nouvelle.",
  "devices.mikrotik.vpn.passphraseWord": "phrase-secrète",
  "devices.mikrotik.vpn.commands": "Commandes pour RouterOS 7.17 ou plus récent",
  "devices.mikrotik.vpn.commandsHint": "Envoyez les deux fichiers sur l’unité (Files), puis collez ces commandes dans son terminal.",
  "devices.mikrotik.band.open": "Allumer ou éteindre, changer la fréquence",
  "devices.mikrotik.band.on": "Radio allumée",
  "devices.mikrotik.band.frequency": "Fréquence",
  "devices.mikrotik.band.auto": "Automatique",
  "devices.mikrotik.band.channel": "{mhz} MHz · canal {n}",
  "devices.mikrotik.band.followsAp": "Une station suit la fréquence de son point d’accès",
  "devices.mikrotik.band.offWarning": "{name} porte une liaison radio. L’éteindre coupe cette liaison : l’unité à l’autre bout n’est plus joignable par elle. Si cette unité est coupée elle aussi, elle rallume la radio d’elle-même au bout de 10 minutes. Éteindre {name} ?",
  "devices.mikrotik.band.applied": "Réglages radio appliqués",
  "devices.mikrotik.band.applying": "Application en cours. Si le changement coupe la connexion, cela peut prendre deux minutes.",
  "devices.mikrotik.band.apply": "Appliquer",
  "devices.vpnPath": "Joint par sa propre connexion VPN : après l’ajout, chargez le .ovpn du site sur le routeur comme client OpenVPN. Rien n’a besoin d’être joignable maintenant.",
  "devices.vpnAdded": "Site ajouté",
  "devices.vpnAddedText": "Chargez son .ovpn sur le routeur ; le site passe en ligne dès qu’il se connecte",
  "devices.teltonika.sim.title": "Carte SIM",
  "devices.teltonika.sim.slot": "SIM {slot}",
  "devices.teltonika.sim.active": "Active",
  "devices.teltonika.sim.locked": "Verrouillée par code PIN",
  "devices.teltonika.sim.unlocked": "Non verrouillée",
  "devices.teltonika.sim.blocked": "Bloquée : code PUK nécessaire",
  "devices.teltonika.sim.unknown": "Inconnu",
  "devices.teltonika.sim.pinTries": "Essais PIN restants : {count}",
  "devices.teltonika.sim.pukTries": "Essais PUK restants : {count}",
  "devices.teltonika.sim.usesCompany": "Code PIN de l'entreprise",
  "devices.teltonika.sim.usesOwn": "Code PIN propre",
  "devices.teltonika.sim.usesOwnNote": "Code PIN propre · {note}",
  "devices.teltonika.sim.usesNone": "Aucun code PIN connu",
  "devices.teltonika.sim.storedMatches": "Code PIN enregistré dans le routeur : correspond",
  "devices.teltonika.sim.storedDiffers": "Code PIN enregistré dans le routeur : ne correspond pas",
  "devices.teltonika.sim.storedUnknown": "Code PIN enregistré dans le routeur : inconnu",
  "devices.teltonika.sim.inactive": "Ce n'est pas la carte SIM active : son état date de la dernière fois qu'elle l'était.",
  "devices.teltonika.sim.switchFirst": "Basculer d'abord sur cette carte SIM",
  "devices.teltonika.sim.lockCompany": "Verrouiller avec le code PIN de l'entreprise",
  "devices.teltonika.sim.useOwn": "Utiliser un code PIN propre",
  "devices.teltonika.sim.change": "Changer le code PIN",
  "devices.teltonika.sim.unlock": "Déverrouiller",
  "devices.teltonika.sim.unblockPuk": "Débloquer avec le code PUK",
  "devices.teltonika.sim.store": "Code PIN enregistré dans le routeur",
  "devices.teltonika.sim.currentPin": "Le code PIN actuel de la carte SIM",
  "devices.teltonika.sim.carrierHint": "une nouvelle carte SIM : le code PIN de l'opérateur",
  "devices.teltonika.sim.keptHint": "vide : le code PIN que Velanox conserve",
  "devices.teltonika.sim.newPin": "Nouveau code PIN (4 à 8 chiffres)",
  "devices.teltonika.sim.simPin": "Le code PIN de la carte SIM",
  "devices.teltonika.sim.puk": "Code PUK (8 chiffres)",
  "devices.teltonika.sim.note": "Note",
  "devices.teltonika.sim.noteHint": "p. ex. prêt de …",
  "devices.teltonika.sim.toCompany": "Utiliser le code PIN de l'entreprise",
  "devices.teltonika.sim.lastTryConfirm": "Il reste un essai. Un code PIN incorrect bloquera la carte SIM jusqu'à la saisie de son code PUK. Continuer ?",
  "devices.teltonika.sim.doneSteps": "Fait : {steps}",
  "devices.teltonika.sim.failedStep": "Non fait : {step}",
  "devices.teltonika.sim.step.change_pin": "code PIN changé",
  "devices.teltonika.sim.step.check_on": "vérification du PIN activée",
  "devices.teltonika.sim.step.check_off": "vérification du PIN désactivée",
  "devices.teltonika.sim.step.unblock": "carte SIM débloquée",
  "devices.teltonika.sim.step.store": "code PIN enregistré dans le routeur",
  "devices.teltonika.sim.step.read": "état lu",
  "devices.teltonika.sim.needsDirect": "Changer le code PIN de la carte SIM nécessite la connexion directe ou VPN du routeur.",
  "devices.teltonika.sim.notRead": "La carte SIM est lue lors de la prochaine synchronisation.",
  "devices.teltonika.sim.pinTriesUnknown": "Essais PIN restants : inconnu",
  "devices.teltonika.sim.unknownTriesConfirm": "Le nombre d'essais restants est illisible : c'est peut-être le dernier, et un code PIN ou PUK incorrect bloquerait la carte SIM. Continuer ?",
  "devices.teltonika.sim.lastPukConfirm": "Il reste un essai PUK. Un code PUK incorrect rendrait maintenant la carte SIM inutilisable pour de bon : seul son opérateur peut la remplacer. Continuer ?",
  "devices.accessFix.teltonika": "Exécutez ceci une fois sur le routeur pour laisser entrer le serveur VPN de Velanox {serverIp} : dans sa WebUI sous System → Maintenance → CLI, ou en SSH depuis le réseau propre du routeur.",
  "devices.accessFix.peplink": "Son API ne le permet pas : dans le Web Admin du routeur, sous System → Admin Security, autorisez HTTPS (port 443) et l’adresse source {serverIp} (le serveur VPN de Velanox) sur la connexion qu’utilise le VPN.",
  "devices.accessFix.copy": "Copier la commande",
}

export default devices
